<template>
  <TrainerLayout>
    <!-- <div
      v-if="step == 2"
      class="flex items-center top-0 absolute mt-20 ml-10 text-xl font-bold text-gray-light tracking-wider px-8"
    >
      Select Thumbnail Image &nbsp;
    </div> -->
    <!-- <div
      v-if="step == 3"
      class="flex items-center top-0 absolute mt-20 ml-10 text-xl font-bold text-gray-light tracking-wider px-8"
    >
      Select Supporting Images &nbsp;
      <p class="text-sm font-normal">(Minimum of 2)</p>
    </div> -->
    <div class="md:px-4 px-0 pb-4">
      <nav class="mb-6" aria-label="breadcrumb">
        <ol
          class="flex flex-col md:flex-row leading-none text-gray-dark md:divide-x-1 divide-x-0 divide-gray-darkest"
        >
          <li class="md:pr-8 pb-2 pt-2">
            <button
              type="button"
              :class="step == 1 ? 'text-green-light' : 'text-gray-dark'"
              @click="onclickSelectStep(1)"
            >
              Class Info
              <span class="text-red-700">
                {{
                  $v.title.$error ||
                  $v.language.$error ||
                  $v.category_id.$error ||
                  $v.difficulty_type.$error ||
                  $v.description.$error ||
                  $v.duration.$error ||
                  $v.duration_hours.$error ||
                  $v.duration_mins.$error
                    ? "*"
                    : ""
                }}
              </span>
            </button>
          </li>
          <li class="md:px-8 pb-2 pt-2">
            <button
              type="button"
              :class="step == 4 ? 'text-green-light' : 'text-gray-dark'"
              @click="onclickSelectStep(4)"
            >
              Pricing Info
              <span class="text-red-700">
                {{ $v.cost.$error ? "*" : "" }}
              </span>
            </button>
          </li>
          <li class="md:px-8 pb-2 pt-2">
            <button
              type="button"
              :class="step == 2 ? 'text-green-light' : 'text-gray-dark'"
              @click="onclickSelectStep(2)"
            >
              Featured Image
              <span class="text-red-700">
                {{ showAlertCircleIcon == false ? "*" : "" }}
              </span>
            </button>
          </li>
          <li class="md:px-8 pb-2 pt-2">
            <button
              type="button"
              :class="step == 3 ? 'text-green-light' : 'text-gray-dark'"
              @click="onclickSelectStep(3)"
            >
              Supporting Images
              <span class="text-red-700">
                {{ isSupportingImageValid == false ? "*" : "" }}
              </span>
            </button>
          </li>
        </ol>
        <ul class="text-red-700">
          <!-- $v.$anyError -->
          <!-- <li v-if="$v.$error">
            <strong>Form has <kbd>error</kbd>.</strong>
          </li> -->
        </ul>
      </nav>
      <form @submit.prevent="handleSessionSubmit" enctype="multipart/form-data">
        <!-- && paramId == null -->
        <template v-if="step == 1">
          <!-- <h3 class="text-lg capitalize mb-4">
            {{ $route.params.id ? "Edit" : "Create" }} Classes
          </h3> -->

          <div
            class="mb-4 text-gray-700 flex flex-wrap -mx-2 space-y-4 md:space-y-0"
          >
            <div class="w-full px-2 md:w-1/2">
              <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1 required">Class Name</label>
              <input
                type="text"
                class="w-full text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                :class="{ 'ring-red-700': $v.title.$error }"
                v-model="$v.title.$model"
                placeholder="Enter Class Name"
              />
              <div v-if="$v.title.$error">
                <span class="text-xs text-red-700" v-if="!$v.title.required">
                  Class Name field is required
                </span>
                <span class="text-xs text-red-700" v-if="!$v.title.maxLength">
                  Class Name must have at most 50 letters.
                </span>
              </div>
            </div>

            <div class="w-full px-2 md:w-1/2">
              <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1 required"> Language </label>
              <!-- :class="{ 'border-red-700': $v.language.$error }" -->
              <select
                class="block w-full form-select text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                v-model="$v.language.$model"
              >
                <option value="">Select</option>
                <option :value="l.id" v-for="l in languagesList" :key="l.id">
                  {{ l.language }}
                </option>
              </select>
              <div v-if="$v.language.$error">
                <span class="text-xs text-red-700" v-if="!$v.language.required">
                  Language field is required
                </span>
              </div>
            </div>
          </div>

          <div
            class="mb-4 text-gray-700 flex flex-wrap -mx-2 space-y-4 md:space-y-0"
          >
            <div class="w-full px-2 md:w-1/2">
              <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1 required"> Class Category </label>
              <!-- :class="{ 'border-red-700': $v.category_id.$error }" -->
              <select
                class="block w-full form-select text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                v-model="$v.category_id.$model"
                @change="handleCategoryChange"
              >
                <option value="">Select</option>
                <option :value="c.id" v-for="c in categoriesList" :key="c.id">
                  {{ c.name }}
                </option>
              </select>
              <div v-if="$v.category_id.$error">
                <span
                  class="text-xs text-red-700"
                  v-if="!$v.category_id.required"
                >
                  Class Category field is required
                </span>
              </div>
            </div>

            <div class="w-full px-2 md:w-1/2">
              <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1 required"> Difficulty </label>
              <!-- :class="{ 'border-red-700': $v.difficulty_type.$error }" -->
              <select
                class="block w-full form-select text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                v-model="$v.difficulty_type.$model"
              >
                <option value="">Select</option>
                <option :value="d.id" v-for="d in difficultiesList" :key="d.id">
                  {{ d.level }}
                </option>
              </select>
              <div v-if="$v.difficulty_type.$error">
                <span
                  class="text-xs text-red-700"
                  v-if="!$v.difficulty_type.required"
                >
                  Class Difficulty field is required
                </span>
              </div>
            </div>
          </div>

          <div class="mb-4 text-gray-700">
            <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1"> Tags </label>
            <InputTag
              v-model="tags"
              :add-tag-on-keys="tagsOnKeys"
              class="rounded-lg flex items-center"
            ></InputTag>
            <div v-if="$v.tags.$error">
              <span class="text-xs text-red-700">
                Special Characters lke [-,?@!<>&] in Tags are not allowed
              </span>
            </div>
          </div>

          <div class="mb-4 text-gray-700">
            <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1 required"> Description </label>
            <textarea
              class="block w-full h-24 text-gray-slate p-3 border-1 border-borderColor focus:outline-none rounded-md"
              v-model="$v.description.$model"
              placeholder="Add your Class description here"
              :class="{ 'ring-red-700': $v.description.$error }"
            ></textarea>
            <div v-if="$v.description.$error">
              <span
                class="text-xs text-red-700"
                v-if="!$v.description.required"
              >
                Description field is required
              </span>
            </div>
          </div>
          <div>
            <p class="text-gray-darker font-medium text-sm md:text-lg mb-2 mb-1">Duration</p>
          </div>
          <div class="mb-4 text-gray-700">
            
            <div
              class="text-gray-700 flex flex-wrap -mx-2 space-y-4 md:space-y-0"
            >
              <div class="w-full px-2 md:w-1/2">
                <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1 required"> Hours </label>
                <!-- @change="handleDuration" -->
                <!-- :class="{ 'border-red-700': $v.duration_hours.$error }" -->
                <select
                  class="block w-full form-select text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                  v-model="$v.duration_hours.$model"
                >
                  <option value="">Select</option>
                  <option
                    v-for="item in DURATION_HOURS"
                    :key="item.id"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="w-full px-2 md:w-1/2">
                <label class="block mb-1 required">Minutes</label>
                <!-- @change="handleDuration" -->
                <!-- :class="{ 'border-red-700': $v.duration_mins.$error }" -->
                <select
                  class="block w-full form-select text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                  v-model="$v.duration_mins.$model"
                >
                  <option value="">Select</option>
                  <option
                    v-for="item in DURATION_MINS"
                    :key="item.id"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
                <div v-if="$v.duration_mins.$error">
                  <span
                    class="text-xs text-red-700"
                    v-if="!$v.duration_mins.required"
                  >
                    Class Duration Minutes field is required
                  </span>
                </div>
              </div>
            </div>
            <div v-if="$v.duration.$error">
              <span class="text-xs text-red-700" v-if="!$v.duration.required">
                Duration field is required
              </span>
              <span class="text-xs text-red-700" v-if="!$v.duration.numeric">
                Accepts only numerics.
              </span>
              <span class="text-xs text-red-700" v-if="!$v.duration.between">
                Duration must be between 30 minutes to 12 hours.
              </span>
            </div>
          </div>
        </template>
        <!-- || paramId == 2 -->
        <keep-alive>
          <template v-if="step == 2">
            <SessionImages
              v-on:thumbnail-image="handleThumbnailImage"
              v-on:thumbnail-id="thumbnailId"
              :details="
                trainerSessionView &&
                trainerSessionView.session &&
                trainerSessionView.session.details
              "
              :categoryId="category_text"
              :thumbnailImageProp="
                sendThumbnailProp ? thumbnailImage : undefined
              "
              :isSupportingImageValid="isSupportingImageValid"
              :showAlertCircleIcon="showAlertCircleIcon"
              :thumbnailImageId="thumbnail_id"
            />
          </template>

          <template v-if="step == 3">
            <SessionSupportingImages
              v-on:supporting-image="handleSupportingImage"
              v-on:remove-supporting-image="removeSupportingImage"
              :supportingImages="
                trainerSessionView && trainerSessionView.supporting_images
              "
              :details="
                trainerSessionView &&
                trainerSessionView.session &&
                trainerSessionView.session.details
              "
              :categoryId="category_text"
              :thumbnailImageProp="
                sendThumbnailProp ? thumbnailImage : undefined
              "
              :isSupportingImageValid="isSupportingImageValid"
              :showAlertCircleIcon="showAlertCircleIcon"
              :thumbnailImageId="thumbnail_id"
            />
          </template>
        </keep-alive>
        <!-- && paramId == null -->
        <template v-if="step == 4">
          <!-- <h3 class="text-lg uppercase">Room Settings</h3> -->

          <label class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1 required">
            Cost of Class
          </label>
          <div class="relative text-gray-700 mb-4">
            <input
              type="text"
              class="w-full text-gray-slate pl-8 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
              :class="{ 'ring-red-700': $v.cost.$error }"
              v-model="$v.cost.$model"
            />
            <div
              class="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none md:h-12 h-10"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-dollar-sign"
              >
                <line x1="12" y1="1" x2="12" y2="23"></line>
                <path
                  d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                ></path>
              </svg>
            </div>
            <!-- <span class="text-xs text-gray-600">
              Paid Classes are not available.
            </span> -->
            <div v-if="$v.cost.$error">
              <span class="text-xs text-red-700" v-if="!$v.cost.required">
                Cost of Classes field is required
              </span>
              <span class="text-xs text-red-700" v-if="!$v.cost.numeric">
                Accepts only numerics.
              </span>
            </div>
          </div>

          <!-- <div
            class="text-gray-700 flex flex-wrap -mx-2 space-y-4 md:space-y-0"
          >
            <div class="w-full px-2 md:w-1/2">
              <label class="block mb-1 required">
                Room Size
                <span class="text-xs capitalize">(total Attendees)</span>
              </label>
              <select
                class="form-select outline-none mt-1 block w-full ring-1 p-2 ring-gray-500 hover:shadow-lg rounded-lg"
                :class="{ 'border-red-700': $v.roomSize.$error }"
                v-model="$v.roomSize.$model"
              >
                <option value="">Select</option>
                <option v-for="item in ROOMSIZE" :key="item.id" :value="item">
                  {{ item }}
                </option>
              </select>
              <div v-if="$v.roomSize.$error">
                <span class="text-xs text-red-700" v-if="!$v.roomSize.required">
                  Room Size field is required
                </span>
              </div>
            </div>

            <div class="w-full px-2 md:w-1/2">
              <label class="block mb-1 required">Webcams Allowed </label>
              <select
                class="form-select outline-none mt-1 block w-full ring-1 p-2 ring-gray-500 hover:shadow-lg rounded-lg"
                v-model="$v.totalWebcamAllowed.$model"
                :class="{ 'border-red-700': $v.totalWebcamAllowed.$error }"
              >
                <option value="">Select</option>
                <option v-for="item in ROOMSIZE" :key="item.id" :value="item">
                  {{ item }}
                </option>
              </select>
              <div v-if="$v.totalWebcamAllowed.$error">
                <span
                  class="text-xs text-red-700"
                  v-if="!$v.totalWebcamAllowed.required"
                >
                  Webcams Allowed field is required
                </span>
              </div>
              <span class="text-xs text-red-700" v-if="limit">
                Webcams cannot be more than room size
              </span>
            </div>
          </div> -->
        </template>

        <div class="flex mt-3 mb-3 justify-end">
          <!-- v-if="step == 1" -->
          <router-link
            v-if="step !== 3"
            :to="{ name: 'sessions', params: { id: 'all' } }"
            class="inline-flex items-center h-10 w-24 px-4 m-2 text-green-light transition-colors duration-150 ring-green-light ring-1 rounded-lg focus:outline-none hover:bg-green-light hover:text-white"
          >
          Cancel
          </router-link>
          <button
            v-else
            type="button"
            @click.prevent="handleSaveExitHandler('exit')"
            class="inline-flex items-center h-10 w-30 px-4 m-2 text-green-light transition-colors duration-150 ring-green-light ring-1 rounded-lg focus:outline-none hover:bg-green-light hover:text-white"
           >
              Save & Exit
           </button>
          <!-- && paramId == null -->
          <!-- <button
            type="button"
            class="h-10 w-24 m-2 text-green-light ring-green-light ring-1 rounded-lg focus:outline-none hover:bg-green-light hover:text-white"
            v-if="step == 2 || step == 3 || step == 4"
            @click.prevent="handlePrevClick"
          >
            Previous
          </button> -->
          <!-- && paramId == null -->
          <button
            type="submit"
            class="h-10 w-24 px-4 m-2 text-green-100 ring-green-light bg-green-light rounded-lg focus:outline-none ring-1 hover:shadow-lg"
            v-if="$route.name == 'SessionEdit'"
          >
            Finish
          </button>
          <div v-else>
            <button
              type="button"
              class="h-10 w-24 px-4 m-2 text-green-100 transition-colors duration-150 ring-green-light bg-green-light rounded-lg focus:outline-none ring-1 hover:shadow-lg"
              @click.prevent="handleNextClick"
              v-if="step == 1 || step == 2 || step == 4"
            >
              Next
            </button>
            <!-- || paramId == 2 -->
            <!-- @click="handleStep(paramId)" -->
            <button
              type="submit"
              class="h-10 w-30 px-4 m-2 text-green-100 ring-green-light bg-green-light rounded-lg focus:outline-none ring-1 hover:shadow-lg flex items-center"
              v-if="step == 3"
            >
              <Calendar class="session-icon mr-1"/> Schedule
            </button>
          </div>
        </div>
      </form>
    </div>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import SessionImages from "@/components/SessionImages";
import SessionSupportingImages from "@/components/SessionSupportingImages";
import InputTag from "vue-input-tag";
import { Calendar} from "@/components/icons";
import {
  between,
  numeric,
  required,
  maxLength,
  minLength,
} from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
  components: {
    TrainerLayout,
    SessionImages,
    SessionSupportingImages,
    InputTag,
    Calendar
  },
  data() {
    return {
      step: 1,
      id: "",
      title: "",
      language: "",
      category_id: "",
      category_text: "",
      difficulty_type: "",
      tags: [],
      description: "",
      thumbnailImage: "",
      thumbnail_url: "",
      supportingImage: [],
      cost: "",
      duration: "",
      duration_hours: "",
      duration_mins: 0,
      roomSize: 200,
      totalWebcamAllowed: 25,
      isSupportingImageValid: true,
      showAlertCircleIcon: true,
      // limit: false,
      sessionId: 0,
      sendThumbnailProp: false,
      thumbnail_id: "",
      paramId: null,
    };
  },
  validations: {
    title: {
      required,
      maxLength: maxLength(50),
    },
    tags: {
      validTagsArr: (tags) => {
        const regex = /[!@#$%^&*(),.?":{}|<>\-]/;
        return !tags.some((tag) => regex.test(tag));
      }
    },
    language: {
      required,
    },
    category_id: {
      required,
    },
    difficulty_type: {
      required,
    },
    description: {
      required,
    },
    thumbnailImage: {
      required,
    },
    cost: {
      required,
      numeric,
    },
    duration: {
      required,
      between: between(30, 720),
      numeric,
    },
    duration_hours: {
      required,
    },
    duration_mins: {
      required,
    },
    // roomSize: {
    //   required,
    // },
    // totalWebcamAllowed: {
    //   required,
    // },
    supportingImage: {
      required,
      minLength: minLength(2),
    },
  },
  computed: {
    ...mapGetters([
      "trainerSessionView",
      "languagesList",
      "categoriesList",
      "difficultiesList",
      "trainerProfileDetails",
    ]),
  },
  methods: {
    ...mapActions([
      "trainerSessionCreate",
      "trainerSessionUpdate",
      "getTrainerSessionView",
      "getLanguagesList",
      "getCategoriesList",
      "getDifficultiesList",
      "getTrainerProfileDetails",
    ]),

    handleCategoryChange(event) {
      this.category_text =
        event.target.options[event.target.options.selectedIndex].text;
    },

    // handleDuration() {
    //   this.$v.duration_hours.$touch();
    //   this.$v.duration_mins.$touch();
    //   this.$v.duration.$model =
    //     this.$v.duration_mins.$model + 60 * this.$v.duration_hours.$model;
    // },

    handleNextClick(caller, value) {
      //step 1 session details validation
      this.$v.title.$touch();
      this.$v.language.$touch();
      this.$v.category_id.$touch();
      this.$v.tags.$touch();
      this.$v.difficulty_type.$touch();
      this.$v.description.$touch();
      this.$v.duration_hours.$touch();
      this.$v.duration_mins.$touch();
      this.$v.duration.$model =
        this.$v.duration_mins.$model + 60 * this.$v.duration_hours.$model;
      if (
        this.$v.title.$invalid ||
        this.$v.language.$invalid ||
        this.$v.category_id.$invalid ||
        this.$v.difficulty_type.$invalid ||
        this.$v.description.$invalid ||
        this.$v.duration_hours.$invalid ||
        this.$v.duration_mins.$invalid ||
        this.$v.duration.$invalid ||
        this.$v.tags.$invalid
      ) {
        console.log("invalid");
        this.step = 1;
        return false;
      } else {
        if (caller && caller === 'selectStep' && value && [1, 4].includes(value)) {
          this.step = value
          return false
        } else {
          this.step = 4
        }
      }
      // step 4 pricing validation
      this.$v.cost.$touch();
      if (this.$v.cost.$invalid) {
        console.log("invalid");
        this.step = 4;
        return false;
      } else {
        if (caller && caller === 'selectStep' && value && [1, 4, 2].includes(value)) {
          this.step = value
          return false
        } else {
          this.step = 2
        }
      }
      // step 2 featured Image validation
      this.$v.thumbnailImage.$touch();
      if (this.$v.thumbnailImage.$invalid) {
        console.log("invalid");
        this.showAlertCircleIcon = false;
        this.step = 2;
        return false;
      } else {
        this.showAlertCircleIcon = true;
        if (caller && caller === 'selectStep' && value && [1, 4, 2, 3].includes(value)) {
          this.step = value
          return false
        } else {
          this.step = 3
        }
      }
      // if (this.thumbnailImage) {
      //   if (
      //     this.thumbnailImage &&
      //     this.thumbnailImage.name &&
      //     /\.(jpe?g|png|gif)$/i.test(this.thumbnailImage.name)
      //   ) {
      //     this.showAlertCircleIcon = true;
      //   } else {
      //     this.showAlertCircleIcon = false;
      //     console.log("invalid");
      //     return false;
      //   }
      // }
      // step 3 supporting Images validation
      this.$v.supportingImage.$touch();
      if (this.$v.supportingImage.$invalid) {
        console.log("invalid");
        this.isSupportingImageValid = false;
        return false;
      } else {
        this.isSupportingImageValid = true;
        if (caller && caller === 'selectStep' && value && [1, 4, 2, 3].includes(value)) {
          this.step = value
          return false
        }
      }
      // } else {
      // this.step++;
      // }
    },
    // handleStep() {
    //   if (this.paramId == 2) {
    //     if (this.step == 2) {
    //       this.$v.thumbnailImage.$touch();
    //       this.$v.supportingImage.$touch();
    //       if (
    //         this.$v.thumbnailImage.$invalid ||
    //         this.$v.supportingImage.$invalid
    //       ) {
    //         if (this.$v.supportingImage.$invalid) {
    //           this.isSupportingImageValid = false;
    //         }
    //         if (this.$v.thumbnailImage.$invalid) {
    //           this.showAlertCircleIcon = false;
    //         }
    //         console.log("invalid");
    //         return false;
    //       }
    //     }
    //   }
    // },

    // handlePrevClick() {
    //   this.sendThumbnailProp = true;
    //   this.step--;
    // },

    handleThumbnailImage(value) {
      this.thumbnailImage = value;
    },

    thumbnailId(val) {
      this.thumbnail_id = val;
    },

    handleSupportingImage(val) {
      this.supportingImage = val;
    },

    removeSupportingImage(val) {
      this.supportingImage = val;
    },

    async handleSessionSubmit(action) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        // console.log("invalid");
        this.handleNextClick();
      } else {
        let data = new FormData();
        data.append("id", this.id);
        data.append("title", this.title);
        data.append("language", this.language);
        data.append("category_id", this.category_id);
        data.append("difficulty_type", this.difficulty_type);
        data.append("tags", this.tags && this.tags.toString());
        data.append("description", this.description);
        data.append("thumbnail_image", this.thumbnailImage);
        data.append("cost", this.cost);
        data.append("duration", this.duration);
        data.append("start_date", "2020-10-10 00:00:00");
        data.append("end_date", "2020-10-10 00:00:00");
        data.append("room_size", this.roomSize);
        data.append("unsplash_image_id", this.thumbnail_id);
        data.append("total_webcam_allowed", this.totalWebcamAllowed);
        if (typeof this.$route.params.id != "undefined") {
          for (var i = 0; i < this.supportingImage.length; i++) {
            data.append("supporting_image[" + i + "]", this.supportingImage[i]);
          }
          this.trainerSessionUpdate(data)
            .then(() => {
              this.$router.push({
                name: "session",
                params: { id: `${this.sessionId}` },
              });
            })
            .catch((e) => console.log(e));
        } else {
          for (var j = 0; j < this.supportingImage.length; j++) {
            data.append("supporting_image[" + j + "]", this.supportingImage[j]);
          }
          this.trainerSessionCreate({data: data, submitAction: action});
        }
      }
    },

    onclickSelectStep(val) {
      // this.step = val;
      this.handleNextClick('selectStep', val)
    },
    handleSaveExitHandler (submitAction) {
      submitAction && submitAction === 'exit' ? this.handleSessionSubmit(submitAction) : ''
    }
  },
  destroyed() {
    this.$destroy();
  },
  async created() {
    this.getLanguagesList();
    this.getCategoriesList();
    this.getDifficultiesList();
    await this.getTrainerProfileDetails();
    this.language =
      this.trainerProfileDetails && this.trainerProfileDetails.primary_language;
    if (typeof this.$route.params.id != "undefined") {
      this.sessionId = this.$route.params.id;
      await this.getTrainerSessionView({ id: this.$route.params.id });
      this.id = this.trainerSessionView.session.details[0].id;
      this.title = this.trainerSessionView.session.details[0].title;
      this.language = this.trainerSessionView.session.details[0].language;
      this.category_id = this.trainerSessionView.session.details[0].category_id;
      this.category_text = this.trainerSessionView.session.details[0].category_name;
      this.difficulty_type = this.trainerSessionView.session.details[0].difficulty_type;
      let duration_hour_min = this.hourToMinConverter(
        this.trainerSessionView.session.details[0].duration
      ).split(":");
      this.duration_hours = duration_hour_min[0];
      // this.duration_mins = duration_hour_min[1];
      this.tags =
        (this.trainerSessionView.session.details[0] &&
          this.trainerSessionView.session.details[0].tags &&
          this.trainerSessionView.session.details[0].tags.split(",")) ||
        [];
      this.description = this.trainerSessionView.session.details[0].description;
      this.thumbnail_url = this.trainerSessionView.session.details[0].thumbnail_url;
      this.supportingImage =
        this.trainerSessionView && this.trainerSessionView.supporting_images;

      for (let i = 0; i < this.supportingImage.length; i++) {
        // this.supportingImage[i].data = this.supportingImage[i].thumbnail_url;
        // Converting the url to file type to remove supporting image error
        await axios
          .post("image-blob", {
            image_url: this.supportingImage[i].thumbnail_url,
          })
          .then((res) => {
            fetch(res.data.data.content)
              .then((response) => response.blob())
              .then((blob) => {
                let file = new File([blob], "filename", {
                  type: blob.type,
                });
                this.supportingImage[i] = file;
              });
          })
          .catch((e) => console.log(e));
      }

      // this.thumbnailImage = this.thumbnail_url;
      //Converting the url to file type to remove thumbnail image error
      await axios
        .post("image-blob", {
          image_url: this.thumbnail_url,
        })
        .then((res) => {
          fetch(res.data.data.content)
            .then((response) => response.blob())
            .then((blob) => {
              let file = new File([blob], "filename", {
                type: blob.type,
              });
              this.thumbnailImage = file;
            });
        })
        .catch((e) => console.log(e));

      this.cost = this.trainerSessionView.session.details[0].cost;
      this.duration = this.trainerSessionView.session.details[0].duration;
      // this.roomSize = this.trainerSessionView.session.details[0].room_size;
      // this.totalWebcamAllowed = this.trainerSessionView.session.details[0].total_webcam_allowed;
    } else {
      if (
        this.trainerSessionView &&
        this.trainerSessionView.session &&
        this.trainerSessionView.session.details
      ) {
        this.trainerSessionView.session.details = [];
        this.supportingImage = [];
      }
    }
    // this.paramId = (await this.$route.query) && this.$route.query.step;
  },
};
</script>
<style>
 .session-icon svg {
  width: 1.25rem !important;
  height: 1.25rem !important;
 }
</style>
